"use strict";
exports.__esModule = true;
exports.chart_color_gold_500 = {
  "name": "--pf-v5-chart-color-gold-500",
  "value": "#c58c00",
  "var": "var(--pf-v5-chart-color-gold-500, #c58c00)"
};
exports["default"] = exports.chart_color_gold_500;